/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function getCursorPosition(field) {
  var cursorPosition = 0;
  if (document.selection) {
    field.focus();
    var oSel = document.selection.createRange();
    oSel.moveStart('character', -field.value.length);
    cursorPosition = oSel.text.length;
  } else if (field.selectionStart || field.selectionStart == '0') {
    cursorPosition = field.selectionStart;
  }
  return cursorPosition;
}
var _default = getCursorPosition;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/packages/ComboBox/src/utils/getCursorPosition.js
// module id = 660
// module chunks = 0